
export class ToolManagamentRebuildOption {
  constructor(
    public hash?: string,
    public name?: string,
    public stockNumber?: number,
    public order?: number
  ) { }

  get optionName(): string {
    return this.name + ' (' + this.stockNumber.toString() + ')';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-managament-rebuild-option.ts